const map = {
	"./absolution_green_sp/description.txt": 84562,
	"./aegis_suit_satin_varnish/description.txt": 34677,
	"./alien_purple/description.txt": 45240,
	"./angel_green_set/description.txt": 29169,
	"./arid_earth_set/description.txt": 89868,
	"./arid_earth_single/description.txt": 9682,
	"./army_green/description.txt": 56829,
	"./army_green_set/description.txt": 89384,
	"./army_green_single/description.txt": 65798,
	"./ash_grey_set/description.txt": 46689,
	"./ash_grey_single/description.txt": 46757,
	"./babe_blond_set/description.txt": 57989,
	"./babe_blond_single/description.txt": 76913,
	"./barbarian_flesh/description.txt": 20057,
	"./battlefied_xp_wasteland_tuft/description.txt": 28137,
	"./battlefield_brown_battleground/description.txt": 37823,
	"./battlefield_rocks_basing/description.txt": 87432,
	"./battlefield_scorched_tuft/description.txt": 80838,
	"./battlefield_xp_deadland_tuft/description.txt": 95269,
	"./battlefield_xp_frozen_tuft/description.txt": 27180,
	"./battlefield_xp_winter_tuft/description.txt": 71923,
	"./battlefield_xp_woodlandtuft/description.txt": 66683,
	"./battlefields_ash_grey/description.txt": 41358,
	"./battlefields_basing_razor_wire/description.txt": 44527,
	"./battlefields_field_grass/description.txt": 29249,
	"./battlefields_grass_green/description.txt": 31664,
	"./battlefields_snow/description.txt": 71317,
	"./battlefields_xp_jungle_tuft_6mm/description.txt": 76657,
	"./battlefields_xp_meadow_flowers/description.txt": 82807,
	"./battlefields_xp_mountain_tuft/description.txt": 14318,
	"./battlefields_xp_swamp_tuft_6mm/description.txt": 14944,
	"./battlefild_xp_highland_tuft/description.txt": 22128,
	"./battlfield_steppe_grass/description.txt": 71286,
	"./blood_red_sp/description.txt": 81944,
	"./camo_cloak_sp/description.txt": 74153,
	"./castle_grey_set/description.txt": 7947,
	"./castle_grey_single/description.txt": 13275,
	"./centaur_skin_set/description.txt": 60697,
	"./centaur_skin_single/description.txt": 78685,
	"./chaotic_red/description.txt": 57843,
	"./cloudburst_blue_sp/description.txt": 1534,
	"./colour_primer_greenskin/description.txt": 5950,
	"./colour_primer_pure_red/description.txt": 34793,
	"./combat_fastique_set/description.txt": 79260,
	"./combat_fastique_single/description.txt": 62786,
	"./commando_green_set/description.txt": 91665,
	"./commando_green_single/description.txt": 82485,
	"./crusader_skin_sp/description.txt": 56837,
	"./crypt_wraith_set/description.txt": 57409,
	"./crypt_wraith_single/description.txt": 30757,
	"./crystal_blue/description.txt": 67455,
	"./crystal_blue_set/description.txt": 194,
	"./crystal_blue_single/description.txt": 32396,
	"./cultist_robe_set/description.txt": 20830,
	"./cultist_robe_single/description.txt": 5984,
	"./daemonic_yellow/description.txt": 81619,
	"./dark_tone/description.txt": 65923,
	"./deep_blue_set/description.txt": 44764,
	"./deep_blue_single/description.txt": 99202,
	"./desert_yellow/description.txt": 88650,
	"./desert_yellow_set/description.txt": 97779,
	"./desert_yellow_single/description.txt": 62787,
	"./dirt_splatter_single/description.txt": 68947,
	"./disgusting_slime_effect/description.txt": 9882,
	"./dragon_red/description.txt": 86127,
	"./dungeon_grey_single/description.txt": 79295,
	"./elf_green_set/description.txt": 55674,
	"./elf_green_single/description.txt": 59479,
	"./elvin_armour_single/description.txt": 27844,
	"./evil_chrome_metallic/description.txt": 55803,
	"./field_grey_set/description.txt": 89145,
	"./field_grey_single/description.txt": 40029,
	"./filthy_cape_set/description.txt": 18009,
	"./filthy_cape_single/description.txt": 78941,
	"./fire_giant_orange_sp/description.txt": 50717,
	"./fog_grey_set/description.txt": 37985,
	"./fog_grey_single/description.txt": 64645,
	"./fur_brown/description.txt": 39118,
	"./fur_brown_set/description.txt": 51807,
	"./fur_brown_single/description.txt": 87143,
	"./gamemaster_terrain_brush_set/description.txt": 23584,
	"./gamemaster_terrain_primer_display/description.txt": 69067,
	"./glitter_green_metalic/description.txt": 32139,
	"./goblin_green/description.txt": 16927,
	"./gorgon_hide_single/description.txt": 42336,
	"./gravelord_grey_sp/description.txt": 65794,
	"./griffon_blue_single/description.txt": 7037,
	"./grimoire_purple_set/description.txt": 74214,
	"./grimoire_purple_single/description.txt": 90344,
	"./gun_metal/description.txt": 66434,
	"./hardened_carapace_set/description.txt": 71927,
	"./hardened_carapace_single/description.txt": 3487,
	"./hardened_leather_sp/description.txt": 23071,
	"./highlord_blue/description.txt": 48720,
	"./hive_dweller_purple_sp/description.txt": 54585,
	"./hobby_brush_basecoating/description.txt": 46830,
	"./hobby_brush_highlighting/description.txt": 72550,
	"./jungle_green_single/description.txt": 93110,
	"./laser_pointer_markerlight/description.txt": 34608,
	"./leather_brown/description.txt": 65410,
	"./light_tone_washes/description.txt": 6219,
	"./light_tone_washes_single/description.txt": 56504,
	"./magic_blue_sp/description.txt": 22846,
	"./malignant_green_sp/description.txt": 76953,
	"./mars_red_set/description.txt": 98316,
	"./mars_red_single/description.txt": 55090,
	"./mid_bown_set/description.txt": 78996,
	"./mid_bown_single/description.txt": 97050,
	"./military_shader_set/description.txt": 26254,
	"./military_shader_single/description.txt": 73840,
	"./moon_dust_set/description.txt": 31499,
	"./moon_dust_single/description.txt": 11419,
	"./most_wanted_brush_set/description.txt": 97809,
	"./mouldy_clothes_set/description.txt": 63756,
	"./mouldy_clothes_single/description.txt": 15058,
	"./mummy_robes_set/description.txt": 72656,
	"./mummy_robes_single/description.txt": 25742,
	"./mutant_hue_set/description.txt": 47685,
	"./mutant_hue_single/description.txt": 1809,
	"./necrotic_flesh/description.txt": 51760,
	"./necrotic_flesh_set/description.txt": 81705,
	"./necrotic_flesh_single/description.txt": 97677,
	"./night_scales/description.txt": 73822,
	"./orc_blood_set/description.txt": 32438,
	"./orc_blood_single/description.txt": 99000,
	"./orc_skin_sp/description.txt": 2804,
	"./palid_bone_sp/description.txt": 67053,
	"./purple_alchemy_sp/description.txt": 25688,
	"./qs_blue_tone_ink_set/description.txt": 33308,
	"./qs_blue_tone_ink_single/description.txt": 59842,
	"./qs_green_tone_ink_single/description.txt": 62531,
	"./qs_purple_tone_ink_set/description.txt": 72078,
	"./qs_purple_tone_ink_single/description.txt": 7952,
	"./qs_red_tone_ink_set/description.txt": 12839,
	"./qs_red_tone_ink_single/description.txt": 43599,
	"./quickshade_wash_mixing_medium_set/description.txt": 758,
	"./quickshade_wash_mixing_medium_single/description.txt": 58680,
	"./runic_grey_sp/description.txt": 33687,
	"./sand_golem_sp/description.txt": 82683,
	"./scaly_hide_set/description.txt": 67878,
	"./scaly_hide_single/description.txt": 38664,
	"./scar_tissue_set/description.txt": 23534,
	"./scar_tissue_single/description.txt": 56496,
	"./skin_tones_paint_set/description.txt": 85367,
	"./slaughter_red_sp/description.txt": 43569,
	"./soft_tone/description.txt": 71155,
	"./spaceship_exterior_set/description.txt": 28666,
	"./spaceship_exterior_single/description.txt": 33764,
	"./speed_paints_starter_paint_set/description.txt": 57765,
	"./speedpaint_medum/description.txt": 39132,
	"./strong_tone/description.txt": 29208,
	"./sulphide_ochre_single/description.txt": 16811,
	"./tainted_gold_metallic_single/description.txt": 75949,
	"./tanned_flesh_set/description.txt": 64810,
	"./tanned_flesh_single/description.txt": 57108,
	"./tool_hobby_sculpting_tools/description.txt": 98479,
	"./tool_miniature_and_model_files/description.txt": 5077,
	"./tool_mixing_balls/description.txt": 56552,
	"./tool_paint_mixing_empty_bottles/description.txt": 72588,
	"./tool_precision_hobby_knife/description.txt": 80938,
	"./tool_tweezer_set/description.txt": 13216,
	"./tools_drill_bits/description.txt": 19152,
	"./toxic_boils_single/description.txt": 6394,
	"./troglodyte_blue_set/description.txt": 21919,
	"./troglodyte_blue_single/description.txt": 34567,
	"./troll_claws_set/description.txt": 44957,
	"./troll_claws_single/description.txt": 75561,
	"./ultramarine_blue/description.txt": 42193,
	"./ultramarine_blue_set/description.txt": 86484,
	"./ultramarine_blue_single/description.txt": 60474,
	"./uniform_grey_set/description.txt": 62410,
	"./uniform_grey_single/description.txt": 28969,
	"./venom_wyrm_set/description.txt": 24138,
	"./venom_wyrm_single/description.txt": 57780,
	"./wargamer__hobby_drybrush/description.txt": 84436,
	"./wargamer_brush_character/description.txt": 90197,
	"./wargamer_brush_detail/description.txt": 92105,
	"./wargamer_brush_kolinsky_masterclass_brush/description.txt": 31930,
	"./wargamer_brush_large_drybrush/description.txt": 39343,
	"./wargamer_brush_monster/description.txt": 7374,
	"./wargamer_brush_regiment/description.txt": 94525,
	"./wargamer_brush_small_drybrush/description.txt": 72551,
	"./wargamer_vehicle_and_scenery/description.txt": 63597,
	"./wargaming_brush_the_psycho/description.txt": 62993,
	"./warpaints_mixing_medium_set/description.txt": 47045,
	"./warpaints_mixing_medium_single/description.txt": 209,
	"./warpaints_quickshade_washes_set/description.txt": 95991,
	"./wasteland_soil_single/description.txt": 26192,
	"./weapon_bronze_set/description.txt": 69598,
	"./weapon_bronze_single/description.txt": 31488,
	"./werewolf_fur_set/description.txt": 41174,
	"./werewolf_fur_single/description.txt": 42680,
	"./wet_mud_set/description.txt": 11158,
	"./wet_mud_single/description.txt": 7000,
	"./witch_brew_single/description.txt": 15787,
	"./zealot_yellow_sp/description.txt": 36960,
	"./zephyr_pink/description.txt": 73917,
	"./zephyr_pink_single/description.txt": 86182,
	"./zombicide_2nd_edition_paint_set/description.txt": 82430
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62705;